import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { type ActionItem, ContainerHeader } from 'shared/ui'
import { useWorkflowListContext } from 'pages/workflows/context/workflowListContext'
import { WorkflowCreateButton, WorkflowHelpGuideButton } from 'pages/workflows/ui'
import { useWorkflowLayoutContext } from 'pages/workflows/context/workflowLayoutContext'

export const WorkflowHeader = observer(() => {
  const { initialLoading, isEmpty } = useWorkflowListContext()
  const workflowLayoutStore = useWorkflowLayoutContext()
  const { titleIconProps, headerMenuTooltipIconProps, headerMenuIconAction } =
    workflowLayoutStore.pageLayoutStore

  const showNewButton = !initialLoading && !isEmpty

  const actions: ActionItem[] = useMemo(() => {
    const makeHelpGuide = () => ({
      iconButtonComponent: <WorkflowHelpGuideButton />,
    })

    const makeWorkflowConfig = (show: boolean) =>
      show ? { iconButtonComponent: <WorkflowCreateButton /> } : null

    return [makeHelpGuide(), makeWorkflowConfig(showNewButton)].filter(
      (action) => !!action
    ) as ActionItem[]
  }, [showNewButton])

  return (
    <ContainerHeader
      height={72}
      title={'Workflows'}
      titleVariant='heading-md'
      actions={actions}
      actionsGap={8}
      titleIconProps={titleIconProps}
      actionIconTooltipProps={headerMenuTooltipIconProps}
      titleIconAction={headerMenuIconAction}
      paddingLeft={20}
      paddingRight={20}
    />
  )
})
